import { useLocalization } from "@shared-ui/localization-context";
import { ViewLarge, Viewport, ViewSmall } from "bernie-view";
import * as React from "react";
import { gtConfig } from "src/stores/wizard/config/staticConfigs/car/gt/gtConfig";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { Level, liveAnnounce } from "uitk-react-utils";

interface GroundTransportSwitchProps {
  onSwapTypeheadLocations: () => void;
  showGTOnly?: boolean;
}

export const GroundTransportSwitch: React.FunctionComponent<GroundTransportSwitchProps> = (props) => {
  const { onSwapTypeheadLocations, showGTOnly } = props;
  const { formatText } = useLocalization();

  const switchA11yText = formatText(gtConfig.switchLocKey);
  const layoutClass = showGTOnly ? "gt-swap-button" : "common-swap-button";

  const actionSwapA11yText = formatText(gtConfig.switchActionLocKey);

  const [switchState, setSwitchState] = React.useState(false);

  const onSwapLocations = () => {
    const liveAnnounceText = switchState ? actionSwapA11yText : `${actionSwapA11yText}.`;
    liveAnnounce(liveAnnounceText, Level.ASSERTIVE);
    setSwitchState(!switchState);
    onSwapTypeheadLocations();
  };

  return (
    <Viewport>
      <ViewSmall>
        <UitkLayoutPosition
          type="absolute"
          position={{ top: "six", right: "four", zindex: "layer3" }}
          className={`${layoutClass}`}
        >
          <UitkSecondaryButton
            onClick={onSwapLocations}
            type="button"
            data-testid="swap_vert"
            aria-label={switchA11yText}
          >
            <UitkIcon id="swap-location" name="swap_vert" size={UitkIconSize.MEDIUM} className="iconColor" />
          </UitkSecondaryButton>
        </UitkLayoutPosition>
      </ViewSmall>
      <ViewLarge>
        <UitkLayoutPosition type="absolute" position={{ top: "one", zindex: "layer3" }} className={`${layoutClass}`}>
          <UitkSecondaryButton
            onClick={onSwapLocations}
            type="button"
            data-testid="swap_horiz"
            aria-label={switchA11yText}
          >
            <UitkIcon id="swap-location" name="swap_horiz" size={UitkIconSize.MEDIUM} className="iconColor" />
          </UitkSecondaryButton>
        </UitkLayoutPosition>
      </ViewLarge>
    </Viewport>
  );
};
